import add_b64_to_url from "@pdfking/workflow/actions/utils/add_b64_to_url"
import get_imposition_dispatch_data from "@pdfking/workflow/actions/utils/get_imposition_dispatch_data"
import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"
import keys from "rfuncs/functions/keys"
import map from "rfuncs/functions/map"
import object_map from "rfuncs/functions/object_map"
import values from "rfuncs/functions/values"

import { submit_prepress_files } from "../../../comp/files/actions/prepress_action"
import settings_get from "../../../constants/settings_get"
import upload_files from "../../../files/actions/upload_files"
import new_file_from_virtualfile from "../../../files/make/new_file_from_virtualfile"
import start_request from "../../../navigation/start_request"

export const create_download_action = () => ["download"]
export const create_prepress_action = session => ["prepress", session]
export const create_change_action = url => ["change", url]

const actions = {
  download: async () => {},
  prepress: async ({ imposition_files }, session) =>
    submit_prepress_files(await imposition_files("single_pdf"), session),
  change: async (s, url) => {
    const existing = object_map(
      f => f.short_name,
      f => f,
      s.existing
    )

    const { actions } = await get_imposition_dispatch_data(
      s.imposition_url("on", "all")
    )

    const files = await upload_files(
      values(
        map(
          (file, path) =>
            existing[path] || new_file_from_virtualfile({ file, path }),
          s.filenames
        )
      )
    )

    void start_request(
      add_b64_to_url(url, s.data) +
        "&" +
        url_query_encode({
          actions: keys(actions),
          files: map(f => f.file_meta.remote_name, files),
        }),
      {
        csrfmiddlewaretoken: settings_get("settings", "csrf_token"),
      }
    )
  },
}

export default ([name, ...args], data) => actions[name](data, ...args)
